var _rect, _rect2, _rect3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 40",
    width: 220,
    height: 40,
    role: "img",
    "aria-label": "LibbenIncorp",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 30,
    height: 30,
    rx: 7,
    fill: "#ffffff",
    fillOpacity: 0.12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 16,
    width: 7,
    height: 14,
    rx: 1.5,
    fill: "#4a72c4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 8,
    height: 19,
    rx: 1.5,
    fill: "#ea591f"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 27,
    fontFamily: "'DM Sans',sans-serif",
    fontSize: 19,
    fontWeight: 700,
    fill: "#e6ecf7"
  }, "Libben", /*#__PURE__*/React.createElement("tspan", {
    fill: "#f07040"
  }, "Incorp"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.bda58d20c1b71c2fc3be4c52fb262b43.svg";
export { ForwardRef as ReactComponent };